<!--
 * @Description: 学生 详情 惩处信息
 * @Author: PF
 * @Date: 2023-11-30 10:50:08
 * @LastEditors: PF
 * @LastEditTime: 2025-07-16 15:04:27
-->
<template>
  <div class="hp100" v-if="tableData.length">
      <el-table :data="tableData" border height="100%" :span-method="spanMethod">
        <el-table-column label="学期" prop="xqmc" align="center" />
        <el-table-column label="违纪类别" prop="wjlbbt" align="center" />
        <el-table-column label="违纪日期" prop="wjrq" width="100" align="center" />
        <el-table-column label="处分名称" prop="cfmcbt" align="center" />
        <el-table-column label="处分日期" prop="cfrq" width="100" align="center" />
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <template #default="scope">
            <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无信息" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, defineProps, watch, computed } from 'vue'
import { loadSelect } from '@/api/common.js'
import { getRowspanMethod } from '@/utils/index.js'
import detail from '@/pages/xuesheng/xueshengjiangcheng/xueshengchengchu/detail.vue'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])
const openDetail = ref(false)
const row = ref({})

const spanMethod = computed(() =>
  getRowspanMethod(tableData.value, ['xqmc'])
)
watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/xuesheng/xueshengchengchu/list', data: tableData, parms: { xsid: props.row.id, order: 'wjrq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>
